import { RecipesCollectionRef } from 'services/firebase';
import RecipeMapper from 'services/mappers/recipes/RecipeMapper';

const onMyRecipesReceived = (userID, onRecipesReceived) => {
  if (!userID) throw new Error('userID cannot be empty');

  const unsubscribe = RecipesCollectionRef()
    .orderBy('createdAt', 'desc')
    .where('userID', '==', userID)
    .onSnapshot((snapshot) => {
      const recipes = [];

      snapshot.forEach((doc) => {
        const data = doc.data();

        recipes.push(RecipeMapper.mapFirebaseRefToModel(doc.id, data));
      });

      onRecipesReceived(recipes);
    });

  return unsubscribe;
};

export default onMyRecipesReceived;
